/**
 * function to show plot to part number
 * Get information from SIP - SAP
 * @param {*} namePlot
 */
export function showPlotsFromPartNumber(namePlot, companyToken, kind, formatype) {
	if (kind === undefined) {
		kind = 1
	}
	if (formatype === undefined) {
		formatype = '0'
	}
	let urlPlot = `${process.env.REACT_APP_SIP_SUPPLIERS}/partnumbers/${namePlot}/${companyToken}/${kind}/${formatype}`
	window.open(urlPlot, '_blank', 'titlebar=no,width=800,height=800,location=no,resizable=yes')
}
